import { capitalize } from 'lodash';
import React from 'react';
import { ethers } from 'ethers';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { formatCurrencyAmount } from '../../../helpers/formatters';
import { IDeposit } from '../../../services/api/api.interfaces';
import { getStatusClass, maxConfirmations } from '../helpers/activity-columns';
import {observer} from 'mobx-react';

interface DepositSmallTableRowProps {
    deposit: IDeposit;
}

const DepositSmallTableRow: React.FC<DepositSmallTableRowProps> = observer(({ deposit }) => {

    let [date, time] = deposit.createdAt.split('T');
    time = time?.split('.')[0];

    let confirmations = deposit.blockProcessed - deposit.blockFound;
    if (confirmations > maxConfirmations) {
        confirmations = maxConfirmations
    }

    return (
        <div className="p-2.5 card-container DepositSmallTableRow mb-1">
            <div className="flex mb-1 justify-between nereus-color-white nereus-body">
                <span>Deposit</span>
                <span>{formatCurrencyAmount(ethers.utils.formatUnits(deposit.amount, tokenDecimals.usdc), 'USDC')}</span>
            </div>
            <div className="flex justify-between nereus-caption">
                <span className="nereus-color-neutral-grey">{date}, {time}</span>
                <span className={getStatusClass(deposit.status)}>{`${confirmations}/${maxConfirmations} ${capitalize(deposit.status)}`}</span>
            </div>
        </div>
    );
});

export default DepositSmallTableRow;
